import styled from 'styled-components'

import { media } from 'featureSliced/shared/utils/breakpoints'

export const ConfirmationModalContainer = styled.div`
  padding-top: 20px;
  color: ${({ theme }) => theme.FontColor};
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  h2 {
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    text-align: center;
    margin-bottom: 20px;
  }
  p {
    text-align: justify;
  }
`

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`

export const BigAnimationContainer = styled.div`
  border-radius: 5px;
  overflow: hidden;
  margin-bottom: 20px;
`

/* Was an inline style of 40vw square — 576px inside the 560px web dialog, which
   on its own forced the modal to scroll (QRM-641). */
export const SmallAnimationContainer = styled.div`
  width: 40vw;
  height: 40vw;
  align-self: center;

  ${media.web} {
    width: 200px;
    height: 200px;
  }
`
